// Funções puras do relatório de redes (Estúdio Social → Métricas).
// Regra da casa: ausente é "—", nunca zero inventado.

export const deltaPercent = (current, previous) => {
  if (current == null || previous == null || previous === 0) return null;
  return ((current - previous) / Math.abs(previous)) * 100;
};

export const formatNumber = (value, locale = 'pt-BR') => {
  if (value == null) return '—';
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(
    value
  );
};

// slots já vêm no fuso da conta (backend): day_of_week 0 = segunda.
export const bestTimeGrid = (slots = []) => {
  const grid = Array.from({ length: 7 }, () => Array(24).fill(null));
  let max = 0;
  slots.forEach(slot => {
    if (grid[slot.day_of_week] === undefined) return;
    grid[slot.day_of_week][slot.hour] = slot;
    max = Math.max(max, slot.avg_engagement || 0);
  });
  return { grid, max };
};

export const heatLevel = (value, max) => {
  if (!value || !max) return 0;
  return Math.min(5, Math.max(1, Math.ceil((value / max) * 5)));
};

export const topDimensions = (list = [], limit = 6) => {
  const total = list.reduce((sum, item) => sum + item.value, 0);
  return [...list]
    .sort((a, b) => b.value - a.value)
    .slice(0, limit)
    .map(item => ({ ...item, share: total ? item.value / total : 0 }));
};

export const seriesMax = values => {
  const numbers = values.filter(value => typeof value === 'number');
  return numbers.length ? Math.max(...numbers) : 0;
};
